import styled from "styled-components";

export const StyledAdsContainer = styled.div`
  padding-top: 1em;
`;
